var map = {
	"./goldcoin/boost-list-icon-1.png": 48877,
	"./memetown/boost-list-icon-1.png": 59093,
	"./reflection/boost-list-icon-1.png": 4495,
	"./tapcoin/boost-list-icon-1.png": 15035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99417;